import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { SensorMergeDto, SensorService, SensorUnitDimensionDto } from '@artemis-software/wr-api';
import SensorUnitEnum = SensorMergeDto.SensorUnitEnum;

@Injectable({
  providedIn: 'root',
})
export class SensorUnitMetadataService {
  private readonly sensorService = inject(SensorService);

  // catchError keeps a failed request from poisoning the signal (toSignal rethrows on every read)
  readonly dimensions = toSignal(
    this.sensorService.getSensorUnits().pipe(catchError(() => of([] as SensorUnitDimensionDto[]))),
    { initialValue: [] as SensorUnitDimensionDto[] },
  );

  private readonly unitDimensions = computed(() => {
    const map = new Map<SensorUnitEnum, SensorUnitDimensionDto.TypeEnum>();
    for (const dimension of this.dimensions()) {
      for (const unit of dimension.units) {
        map.set(unit.type, dimension.type);
      }
    }
    return map;
  });

  unitsOfSameDimension(unit: SensorUnitEnum | undefined | null): SensorUnitEnum[] {
    const all = Object.values(SensorUnitEnum);
    if (!unit) {
      return all;
    }
    const unitDimensions = this.unitDimensions();
    if (!unitDimensions.size) {
      // metadata not loaded (yet) — don't filter, the backend validates on merge
      return all;
    }
    const dimension = unitDimensions.get(unit);
    if (!dimension || dimension === SensorUnitDimensionDto.TypeEnum.None) {
      return [];
    }
    return all.filter((candidate) => unitDimensions.get(candidate) === dimension);
  }
}
